import type { RatioTypeEnum } from 'gql/graphql';
import { Tabs, cnListItem, cnListItemGrid, cnMixSpace, cnTabsTab, cnText } from 'uikit';

import cn from 'classnames';
import * as R from 'ramda';
import { useMemo, useState, useCallback } from 'react';

import { ratioNames } from '../../constants';

type TabItem = { id: string; name: string; count: number };

interface IAddCoefficientTabsTypesProps {
    countItems: { [key: string]: number };
    onChangeActiveTab: (id: RatioTypeEnum) => void;
    className?: string;
    view?: 'bordered' | 'clear';
}

export const AddRatiosModalTabs = ({
    countItems,
    onChangeActiveTab,
    className,
    view = 'clear',
}: IAddCoefficientTabsTypesProps) => {
    const items: TabItem[] = useMemo(
        () => Object.entries(ratioNames).map(([value, name]) => ({ id: value, name, count: countItems[value] })),
        [countItems],
    );

    const [activeTab, setActiveTab] = useState<TabItem>(items[0]);

    const handleTabChange = useCallback(
        ({ value }) => {
            setActiveTab(value);
            onChangeActiveTab(value.id);
        },
        [onChangeActiveTab],
    );

    return (
        <div className={className}>
            <Tabs
                items={items}
                getItemLabel={R.prop('name')}
                onChange={handleTabChange}
                value={activeTab}
                view={view}
                renderItem={({ label, checked, onChange, item }) => (
                    <button
                        type="button"
                        onClick={onChange}
                        className={cn(
                            cnText({ size: 'm', type: 'button', view: 'primary' }),
                            cnListItem(),
                            cnListItemGrid(),
                            cnTabsTab({ checked }),
                            'MixFocus MixFocus_before',
                            cnMixSpace({ pB: '2xs' }),
                        )}
                    >
                        {label}
                        {!!item.count && <span style={{ marginLeft: 4 }}>{item.count}</span>}
                    </button>
                )}
            />
        </div>
    );
};

AddRatiosModalTabs.displayName = 'AddCoefficientTabsTypes';
